import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';

@Component({
  selector: '[mft-applynow]',
  templateUrl: "./applynow.component.html"
})
export class ApplyNowComponent implements OnInit, AfterViewInit {
  constructor(private authService: AuthService, private appCommonService: AppCommonService) {
    
  }
  ngOnInit() {

  }

  ngAfterViewInit() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/applynow.component.ts